import { ResponseError } from '@/utils/fetch'

export const toReject = (request) => {
  return async (...params) => {
    const { code, data, msg } = await request(...params)
    if (code !== 200) {
      throw new ResponseError(code, msg, data)
    }
    return data
  }
}

export const queryString = (object) => {
  return new URLSearchParams(
    Object.fromEntries(
      Object.entries(object).filter(([_, v]) => v != null) // 过滤 null 和 undefined
    )
  ).toString()
}
